<template>
  <div class="document-container">
    <div v-if="showList">
      <ul class="vaccine-document-list">
        <div
          v-for="key in Object.keys(currentDocumentDetails)"
          :key="key"
          class="vaccine-list-container"
        >
          <li
            class="d-flex flex-column justify-content-center"
            :class="{ 'pb-3 mt-3': key == 'Vaccine File' }"
          >
            <p class="document-label">{{ key }}</p>
            <img
              v-viewer
              class="document-img mt-2"
              v-if="
                key == 'Vaccine File' &&
                (document_file_src || currentDocumentDetails[key])
              "
              :src="document_file_src || currentDocumentDetails[key]"
            />
            <p v-else class="document-value">
              {{
                currentDocumentDetails[key].charAt(0).toUpperCase() +
                currentDocumentDetails[key].slice(1)
              }}
            </p>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["documentDetails", "document_file_src"],
  data() {
    return {
      showList: false,
      currentDocumentDetails: {},
    };
  },
  beforeMount() {
    Object.keys(this.documentDetails).forEach((key) => {
      if (this.documentDetails[key] && this.documentDetails[key] != "null") {
        this.showList = true;
        this.currentDocumentDetails[key] = this.documentDetails[key];
      }
    });
  },
};
</script>

<style lang="scss">
p {
  margin: 0;
}
.document-container {
  width: 415px;
  background: #f2f2f2;
  border-radius: 4px;
  margin-top: 8px;
  .document-label,
  .document-value {
    margin-inline-start: 10px;
  }
}

.vaccine-document-list {
  padding-top: 10px;
  padding-inline-start: 20px;
  li {
    height: 70px;
    border-bottom: 1px solid #cecccc;
  }
  .vaccine-list-container:last-child > li {
    border-bottom: none;
  }
}

.document-label {
  color: #939393;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: start;
}

.document-value {
  color: #495057;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: start;
  margin-top: 5px;
}
.document-img {
  width: 56px;
  height: 45.4px !important;
  margin-inline-start: 10px;
  border-radius: 3px;
}
</style>
